export const COMP_ITEM_CATEGORY_OPTIONS = [
  { label: 'Bonus', value: 'bonus' },
  { label: 'Allowance', value: 'allowance' },
  { label: 'Benefit', value: 'benefit' }
];

export const COMP_ITEM_CODES_BY_CATEGORY = {
  bonus: [
    { label: 'Performance bonus', value: 'performance_bonus' },
    { label: 'Signing bonus', value: 'signing_bonus' },
    { label: 'Annual bonus', value: 'annual_bonus' },
    { label: 'Other bonus', value: 'other' }
  ],
  allowance: [
    { label: 'Housing allowance', value: 'housing' },
    { label: 'Transport allowance', value: 'transport' },
    { label: 'Meal allowance', value: 'meal' },
    { label: 'Phone allowance', value: 'phone' },
    { label: 'Other allowance', value: 'other' }
  ],
  benefit: [
    { label: 'Health insurance', value: 'health_insurance' },
    { label: 'Worker Compensation', value: 'workers_compensation' },
    { label: 'Life Insurance', value: 'life_insurance' },
    { label: 'Dental & Vision Coverage', value: 'dental_vision' },
    { label: '401(K) Retirement Plan Enrollment', value: 'retirement_401k' },
    { label: 'Other benefit', value: 'other' }
  ]
};

export const COMP_ITEM_FREQUENCY_OPTIONS = [
  { label: 'Monthly', value: 'monthly' },
  { label: 'Annual', value: 'annual' },
  { label: 'One-time', value: 'one_time' }
];

export const COMP_ITEM_MAX = 40;
